import { RestrictedAccountContent } from "@src/appV2/redesign/ClipboardScore/components/BottomSheets/RestrictedAccountContent";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";

interface YourAccountIsRestrictedPageProps {
  readonly isFinalRestriction: boolean;
  readonly liftTime?: string;
  readonly reEnrollmentScore: number;
  readonly onContinue: () => void;
}

export function YourAccountIsRestrictedPage(props: YourAccountIsRestrictedPageProps) {
  const { isFinalRestriction, liftTime, reEnrollmentScore, onContinue } = props;

  return (
    <PageWrapper
      sx={{
        background:
          // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
          "linear-gradient(180deg, rgba(251, 242, 232, 1) 0%, rgba(247, 208, 208, 1) 100%)",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <RestrictedAccountContent
        enableViewAnalytics
        isFinalRestriction={isFinalRestriction}
        liftTime={liftTime}
        reEnrollmentScore={reEnrollmentScore}
        onContinue={onContinue}
      />
    </PageWrapper>
  );
}
